{
    "Accessibility menu": "رسائی مینو",
    "Close": "بند کریں",
    "Text and Reading": "متن اور پڑھنا",
    "Navigation and Interaction": "نیویگیشن اور تعامل",
    "Text Align": "متن کی سیدھ",
    "Align Left": "بائیں سیدھ کریں",
    "Align Center": "درمیان میں سیدھ کریں",
    "Align Right": "دائیں سیدھ کریں",
    "Adjust Font Size": "فونٹ سائز ایڈجسٹ کریں",
    "Highlight Title": "عنوان کو نمایاں کریں",
    "Highlight Links": "لنکس کو نمایاں کریں",
    "Readable Font": "قابلِ مطالعہ فونٹ",
    "Color and Contrast": "رنگ اور تضاد",
    "Dark Contrast": "گہرا تضاد",
    "Light Contrast": "ہلکا تضاد",
    "High Contrast": "زیادہ تضاد",
    "High Saturation": "زیادہ سیچوریشن",
    "Low Saturation": "کم سیچوریشن",
    "Monochrome": "مونوکروم",
    "Tools": "اوزار",
    "Reading Guide": "مطالعہ گائیڈ",
    "Big Cursor": "بڑا کرسر",
    "Increase Font Size": "فونٹ سائز بڑھائیں",
    "Decrease Font Size": "فونٹ سائز کم کریں",
    "Letter Spacing": "حروف کا فاصلہ",
    "Line Height": "لائن کی اونچائی",
    "Font Weight": "فونٹ کا وزن",
    "Dyslexia Font": "ڈسلیکسیا فونٹ",
    "Language": "زبان",
    "Accessibility widget": "رسائی مینو کھولیں",
    "Accessibility Profiles": "رسائی پروفائلز",
    "Cognitive Disability": "ادراکی معذوری",
    "Seizure Safe": "دورے سے محفوظ",
    "Accessibility statement": "رسائی کا بیان",
    "ADHD": "اے ڈی ایچ ڈی",
    "Low Vision": "کمزور بینائی",
    "Pause Animations": "حرکات روکیں",
    "Animation paused": "اینیمیشن روک دی گئی",
    "Reset all settings": "ترتیبات ری سیٹ کریں",
    "Shortcut:": "شارٹ کٹ:",
    "Epilepsy Safe Mode": "مرگی کے لیے محفوظ موڈ",
    "Mute sounds": "آوازیں خاموش کریں",
    "Page read": "صفحہ پڑھیں",
    "Page read controls": "صفحہ پڑھنے کے کنٹرول",
    "Pause": "وقفہ",
    "Resume": "دوبارہ شروع کریں",
    "Stop": "روکیں",
    "Settings": "ترتیبات",
    "Speed": "رفتار",
    "Voice": "آواز",
    "Close accessibility menu": "رسائی کا مینو بند کریں",
    "Back to accessibility menu": "رسائی کے مینو پر واپس جائیں",
    "Search languages": "زبانیں تلاش کریں",
    "Selected language": "منتخب کردہ زبان",
    "View accessibility statement (opens in new window)": "رسائی کا بیان دیکھیں (نئی ونڈو میں کھلتا ہے)",
    "Visit CookieYes website (opens in new window)": "CookieYes ویب سائٹ ملاحظہ کریں (نئی ونڈو میں کھلتا ہے)",
    "Reset all accessibility settings to default": "رسائی کی تمام ترتیبات کو ڈیفالٹ پر بحال کریں"
}
